<template>
  <b-card title="Daikin Counter List">
    <b-col cols="12">
      <b-row class="mb-2">
        <b-col cols="4">
          <b-button v-if="permission.add" @click="toAddCounter" variant="success">
            Add Counter
          </b-button>
        </b-col>
        <b-col cols="4">
          <!-- <b-button @click="toCheckStockAPI" variant="success">
                        To Check Stock API
                    </b-button> -->
        </b-col>
        <!-- <b-col cols="4"/> -->
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
            :fields="fields"
            :items="counterData"
            :busy.sync="tableLoading"
            show-empty
          >
            
            <template #cell(actions)="row">
              <b-dropdown
                id="dropdown-dropleft"
                variant="primary"
                size="sm"
                text="Menu"
                no-caret
              >
                <template #button-content>
                  <feather-icon size="1x" icon="MenuIcon" />
                </template>
                <b-dropdown-item style="text-align:center">
                    <b-button variant="info" @click="toDetailCounter(row.item._id)">
                      <feather-icon icon="EyeIcon"/>
                    </b-button>
                  </b-dropdown-item>
                <b-dropdown-item
                  style="text-align:center"
                  v-if="permission.edit"
                >
                  <b-button
                    variant="outline-primary"
                    @click="toEditCounter(row.item._id)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                </b-dropdown-item>
                <b-dropdown-item
                  style="text-align:center"
                  v-if="permission.delete"
                >
                  <b-button variant="danger" @click="doDeleteCoutner(row.item._id)">
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            @change="onPageChange"
            v-model="currentPage"
            style="float: right"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapActions,mapState } from "vuex";
import { userAccess } from "@/utils/utils";
import { dateFormat } from "@/utils/utils";

export default {
  data() {
    return {
      fields: [
        { key: "name", label: "Name", filterable: true, sortable: true },
        { key: "actions", label: "Action" },
      ],
      counterData: [],
      totalRows:1,
      currentPage: 1,
      perPage: 10,
    };
  },
  mounted() {
    this.queryCounter()
  },
  methods: {
    ...mapActions({
      getCounters: "counter/getCounters",
      deleteCounter: "counter/deleteCounter",
    }),
    onPageChange(page){
      this.currentPage=page;
      this.queryCounter()

    },
    
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      this.tableLoading = false;
    },
    dates(date) {
      return dateFormat(date);
    },
    queryCounter() {
      this.tableLoading=true;

    this.getCounters({
      warehouse:'daikin',
      page:this.currentPage,
      entry:this.perPage
    }).then((data) => {
      this.counterData = data.data
      this.processMetadata(data.metadata)
      this.tableLoading = false
    }).catch((e) => {
      this.tableLoading = false
      this.$bvToast.toast("Load data failed, please reload the page.", {
      title: "Warning",
      variant: "danger",
      solid: true,
      });
      console.log(e);
    });
    },
    doDeleteCoutner(id) {
      var deleteID=id;
      confirm("Are You sure want to delete this Counter ?");
      this.$store
        .dispatch("counter/deleteCounter", {id:id})
        .then(() => {
          this.queryCounter()
        })
        .catch((err) => {
          console.error({ err });
        });
    },
    toDetailCounter(id){
      this.$router.push(`/counter/view/${id}`);
    },
    toAddCounter() {
      this.$router.push("/counter/add/daikin");
    },
    toEditCounter(id) {
      this.$router.push(`/counter/edit/${id}`);
    }
  },
  computed: {
    
    permission() {
      let result = userAccess("Counter Daikin", "counter_menu");
      // console.log("Delivery Orders Sumitomo",result)
      return result;
    },
  },
  created() {
    document.title = "Daikin Counter | RSP";
  },
};
</script>
